import { useBannersData } from "@faire/retailer-visitor-shared/components/Banners/DataFetching/__internal__/useBannersData";
import { SearchResultsBanner } from "@faire/retailer-visitor-shared/components/Banners/SearchBanners/SearchResultsBanner";
import { IBannerData } from "@faire/retailer-visitor-shared/lib/bannerUtils";
import { useSettingBatch9LoggedOutPagesInlineBanner } from "@faire/retailer-visitor-shared/settings/useSettingBatch9LoggedOutPagesInlineBanner";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useSearchPageBannersDataContext } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/ViewState/SearchPageBannersDataContext";
import { useSearchPageIsFromDiscoverURL } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageIsFromDiscoverURL";
import { ISearchCatNavBannersResponse } from "@faire/web-api--source/indigofair/data/ISearchCatNavBannersResponse";
import { useMemo } from "react";

export const useSearchPageBannersResponse = (
  bannersResponse: ISearchCatNavBannersResponse | undefined
) => {
  const { sign_up_product_grid_banner } = bannersResponse ?? {};

  const isDiscoverPage = useSearchPageIsFromDiscoverURL();
  const useNewInlineBanner = useSettingBatch9LoggedOutPagesInlineBanner();
  const eligibleBannersDisplayDataInPriorityOrder = useMemo(() => {
    const data: IBannerData<SearchResultsBanner>[] = [];
    if (sign_up_product_grid_banner) {
      // This banner is logged-out only and so we do not need to worry about
      // its position relative to other logged-in only banners.
      if (useNewInlineBanner || isDiscoverPage) {
        data.push({
          type: SearchResultsBanner.SIGN_UP_PRODUCT_GRID_BANNER,
          fullRowBanner: true,
          row: 3,
          size: 0,
          column: 1,
        });
      } else {
        data.push({
          type: SearchResultsBanner.SIGN_UP_PRODUCT_GRID_BANNER,
          column: 1,
          row: 3,
          size: 2,
        });
      }
    }

    return data;
  }, [sign_up_product_grid_banner, useNewInlineBanner, isDiscoverPage]);

  const { replacedProductTilesCount, displayableBannersWithAdjustedRow } =
    useBannersData<SearchResultsBanner>(
      eligibleBannersDisplayDataInPriorityOrder
    );

  return useMemo(
    () => ({
      bannersResponse,
      bannersDisplayData: eligibleBannersDisplayDataInPriorityOrder,
      replacedProductTilesCount,
      displayableBannersWithAdjustedRow,
    }),
    [
      bannersResponse,
      eligibleBannersDisplayDataInPriorityOrder,
      replacedProductTilesCount,
      displayableBannersWithAdjustedRow,
    ]
  );
};

export const useSearchPageBannersData = () => {
  return useSearchPageBannersDataContext();
};
